import React, { useEffect } from "react";
import HeroAbout from "../../../components/Landing/HeroAbout";
import Quote from "../../../components/Landing/QuoteAbout";
import OurVision from "../../../components/Landing/OurVision";
const About = () => {
  useEffect(() => {
    document.title = "Snilink - About";
  }, []);
  return (
    <>
      <HeroAbout />
      <Quote />
      <OurVision />
    </>
  );
};
export default About;
